import React, { ComponentPropsWithoutRef, FC } from 'react';
import cn from 'classnames';

interface Props extends ComponentPropsWithoutRef<'input'> {
  className?: string;
}

const Input: FC<Props> = ({ className = '', ...props }) => (
  <input
    {...props}
    type="text"
    className={cn(
      className,
      'appearance-none w-full border py-8 px-10 bg-white placeholder-grey-1 pointer:text-md-mobile',
      props.disabled && 'text-grey-3',
    )}
  />
);

export default Input;
